import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiConstants } from '../../../data/constants';

interface IAccounts {
  token: string;
  username: string;
  password: string;
  accountid: string;
  folder: string;
}

export const deleteAccountThunk = createAsyncThunk(
  'CSDesktop/deleteAccountThunk',
  async (props: IAccounts) => {
    const response = await fetch(apiConstants.apiUrl + '/delaccount', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token: props.token,
      },
      body: JSON.stringify({ ...props, token: '' }),
    });
    const data = await response.json();
    return data;
  },
);
